import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "welcome-pane-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ibex-logo" }, null, -1)
const _hoisted_3 = { class: "highlighted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_i18n_t, {
      class: "welcome-text",
      keypath: "login.welcome",
      tag: "span"
    }, {
      GALEN: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("login.galen")), 1)
      ]),
      _: 1
    })
  ]))
}